import { format, isValid, parseISO } from 'date-fns';

export const safeFormatDate = (value: string, pattern: string): string => {
  const date = parseISO(value);
  return value && isValid(date) ? format(date, pattern) : '';
};

export const formatDateRange = (from: string, to: string) => ({
  formattedFrom: safeFormatDate(from, 'MM/dd/yyyy'),
  formattedTo: safeFormatDate(to, 'MM/dd/yyyy'),
});

export const formatReleaseDate = (value: string): string =>
  safeFormatDate(value, 'yyyy-MM-dd');
